import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';

const appRoutes = {
  home: "/home",
  integrations: {
    list: "/connections-integrations",
    oauthCallback: "/connections-integrations/oauth-callback/[provider]",
    detail: {
      view: "/connections-integrations/[integrationId]",
      traverseView: "/sources/[integrationId]/[type]",
      config: "/connections-integrations/[integrationId]/config"
    }
  },
  inbox: "/saved",
  shared: {
    resource: "/i/[token]",
    space: "/s/[token]"
  },
  auth: {
    signin: "/signin",
    confirmWithClaimSessionToken: "/signup/confirm-redirect",
    confirmEmail: "/signup/confirm",
    signup: "/signup"
  },
  onboarding: {
    profile: "/onboard/profile",
    /**
    * NOT WORKING
    * something with the compatibility layer
    * @deprecated
    */
    welcome: getCompatEnv().isFabricProd ? "/app-welcome" : "/onboard/dummy",
    connectingTheDots: getCompatEnv().isFabricProd ? "/onboard/connecting-the-dots" : "/onboard/dummy"
  },
  oauth: {
    authorize: "/oauth/authorize"
  },
  folder: {
    detail: "/folders/[folderId]"
  },
  space: {
    list: "/spaces",
    detail: "/spaces/[spaceId]"
  },
  mirror: {
    /**
    * use mirrorRegistry.rootId
    */
    detail: "/folders/[folderId]"
  },
  autoJoin: "/add-to-library",
  tags: {
    list: "/tags"
  },
  notFound: "/404",
  smartCollections: {
    create: "/smart-collections/create",
    list: "/smart-collections",
    detail: "/smart-collections/[smartCollectionId]"
  },
  appStore: {
    root: "/store",
    sources: "/store/sources",
    appsAndPlugins: "/store/apps-plugins",
    fabricApps: "/store/fabric-apps",
    import: "/store/import",
    fabricForDevelopers: "/store/fabric-for-developers"
  },
  publishing: {
    publishedItem: "/p/[slug]-[accessToken]"
  },
  userReferral: `/settings/referral`,
  pricing: "/pricing",
  settings: {
    account: "/settings/account"
  },
  exportStatus: "/export/[exportId]"
};
const generatePathResourceDetail = (resourceId, options) => {
  const view = options?.view || "home";
  switch (view) {
    case "home":
      return "/home?expandedFdocId=[resourceId]".replace("[resourceId]", resourceId);
    case "inbox":
      return "/saved/?expandedFdocId=[resourceId]".replace("[resourceId]", resourceId);
    case "notifications":
      return "/notifications?expandedFdocId=[resourceId]".replace("[resourceId]", resourceId);
  }
};

export { appRoutes, generatePathResourceDetail };
//# sourceMappingURL=routes.config.js.map
